export const getDefaultStateSound = (): number => {
  const storedValue = localStorage.getItem('isSoundOn')

  return storedValue ? Number(JSON.parse(storedValue)) : 1
}
